import type { ReactNode, TableHTMLAttributes } from 'react';

import styles from './Table.module.css';

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  bare?: boolean;
  children: ReactNode;
}

export function Table({ bare, className, children, ...rest }: TableProps) {
  return (
    <div className={[styles.scroll, bare && styles.bare].filter(Boolean).join(' ')}>
      <table className={[styles.table, className].filter(Boolean).join(' ')} {...rest}>
        {children}
      </table>
    </div>
  );
}

export function TableActions({ children }: { children: ReactNode }) {
  return <div className={styles.actionsInner}>{children}</div>;
}
